export default __webpack_public_path__ + "static/flag-es-5d6e5e83ae75a0ba9c85802d8a48d01d.svg";